export enum DirectionEnum {
  Default = 'default',
  Reverse = 'reverse'
}

export type DirectionType = 'default' | 'reverse';
